import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		invoice: 1,
		is_sub: 0
	},
	mutations: {
		setState: function(state,num){
			state.invoice = num;
		},
		setState2: function(state,num){
			state.is_sub = num;
		}
	},
	actions: {
		setStateFun: function(context,n){
			context.commit('setState',n);
		},
		setStateFun2: function(context,n){
			context.commit('setState2',n);
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js